/**
 * Contact Service - EmailJS Version (Alternative to Backend API)
 * Uses EmailJS to send emails directly from the frontend
 * More reliable than SMTP for serverless/cloud deployments
 */

import emailjs from '@emailjs/browser';

export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
  consent: boolean;
}

export interface ContactApiResponse {
  success: boolean;
  message: string;
}

// Initialize EmailJS with the public key
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '';

if (PUBLIC_KEY) {
  emailjs.init(PUBLIC_KEY);
}

/**
 * Send contact message using EmailJS
 * @param data Contact form data
 * @returns Promise with success status
 */
export const sendContactMessageEmailJS = async (
  data: ContactFormData
): Promise<ContactApiResponse> => {
  try {
    // Validate consent
    if (!data.consent) {
      throw new Error('Le consentement est requis');
    }

    // EmailJS configuration
    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';

    // Verify configuration
    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      throw new Error('Configuration EmailJS manquante. Vérifiez vos variables d\'environnement.');
    }

    console.log('📧 Envoi avec EmailJS...', {
      serviceId: SERVICE_ID,
      templateId: TEMPLATE_ID,
      publicKey: PUBLIC_KEY.substring(0, 5) + '...'
    });

    // Send email via EmailJS
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        from_name: data.name,
        from_email: data.email,
        subject: data.subject,
        message: data.message,
        to_email: 'n.benadda.dev@gmail.com'
      }
    );

    console.log('✅ EmailJS Response:', response);

    return {
      success: true,
      message: 'Message envoyé avec succès'
    };
  } catch (error: any) {
    console.error('❌ Erreur EmailJS:', error);
    
    // Log detailed error information
    if (error.text) {
      console.error('Error text:', error.text);
    }
    if (error.status) {
      console.error('Error status:', error.status);
    }
    
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    
    throw new Error('Impossible d\'envoyer le message. Veuillez réessayer.');
  }
};
